import { DTODocumentationDraftState } from "./draft-state";
import { DTODocumentationGroupV2 } from "./group-v2";
import { DTODocumentationPageV2 } from "./page-v2";
import { z } from "zod";
export const DTODocumentationHierarchyV2 = z.object({
    pages: z.array(DTODocumentationPageV2.extend({
        /** Defined when a page has changed since last publish and can be included into a partial publish */
        draftState: DTODocumentationDraftState.optional(),
    })),
    groups: z.array(DTODocumentationGroupV2.extend({
        /** Defined when a page has changed since last publish and can be included into a partial publish */
        draftState: DTODocumentationDraftState.optional(),
    })),
    /** True if the documentation was already published, false otherwise. */
    hasPublishedDocumentationContent: z.boolean(),
});
